import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"
import {
  ConsultantProfileQuery,
  ConsultantProfileQueryQueryVariables,
  ConsultantProfileQueryQuery,
  ConsultantProfile,
  ConsultantOpenOpportunitiesQuery,
  ConsultantOpenOpportunitiesQueryQuery,
  ConsultantOpenOpportunitiesQueryQueryVariables,
} from "@/gql"
import MissionUpdates from "@/modules/Missions/components/MissionUpdates/MissionUpdates.vue"
import TasksWidget from "@/components/tasks/TasksWidget.vue"
import AppPage from "@/components/layout/AppPage.vue"
import OpenRolesCard from "@/modules/Consultant/Homepage/OpenRolesCard.vue"
import OnboardingCheckListCard from "@/modules/Consultant/Homepage/OnboardingCheckListCard.vue"
import { useConsultantOnboardingChecklist } from "@/modules/Consultant/hooks/useConsultantOnboardingChecklist"
import UnreadConversations from "@/modules/Consultant/Homepage/UnreadConversations.vue"
import PendingMissionDeliverables from "@/modules/Consultant/Homepage/PendingMissionDeliverables.vue"
import ConsultantProfileSummary from "@/modules/Consultant/Homepage/ConsultantProfileSummary.vue"
import { useQuery } from "@vue/apollo-composable"
import { usePageState } from "@/hooks/usePageState"
import PageStateError from "@/components/widgets/common/PageStateError.vue"
import { PageState } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantHome',
  setup(__props) {

const pageState = ref(PageState.Loading)

const { loading, onError, onResult } = useQuery<
  ConsultantProfileQueryQuery,
  ConsultantProfileQueryQueryVariables
>(ConsultantProfileQuery)

const { result: consultantOpenOpportunitiesResult } = useQuery<
  ConsultantOpenOpportunitiesQueryQuery,
  ConsultantOpenOpportunitiesQueryQueryVariables
>(ConsultantOpenOpportunitiesQuery)

const { handlePageErrorState } = usePageState(pageState)

onError((error) => {
  handlePageErrorState(error)
})

const consultantProfile = ref<ConsultantProfile | null>(null)

onResult((result) => {
  if (result?.data?.consultantProfile) {
    consultantProfile.value = result.data.consultantProfile as ConsultantProfile
    return
  }
  consultantProfile.value = null
})

const hasOnboardingItems = computed(() => {
  if (!consultantProfile.value) return false
  const { hasOnboardingItems } = useConsultantOnboardingChecklist(consultantProfile.value)
  return hasOnboardingItems.value
})

return { __sfc: true,pageState, loading, onError, onResult, consultantOpenOpportunitiesResult, handlePageErrorState, consultantProfile, hasOnboardingItems, MissionUpdates, TasksWidget, AppPage, OpenRolesCard, OnboardingCheckListCard, UnreadConversations, PendingMissionDeliverables, ConsultantProfileSummary, PageStateError, PageState }
}

})